import {
	Play,
	Search,
	SearchLyrics,
	Sparkle,
} from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

import type {
	SearchSelectorOptionProps,
	SearchType,
} from '../SearchSelector.types'
import styles from './SearchSelectorOption.module.css'

export type { SearchSelectorOptionProps }

export const getIcon = (type: SearchType): JSX.Element | undefined => {
	switch (type) {
		case 'keywords':
			return (
				<span className={clsx(styles.iconTile, styles.iconKeywords)}>
					<Search color="black" />
				</span>
			)
		case 'prompt':
			return (
				<span className={clsx(styles.iconTile, styles.iconPrompt)}>
					<Sparkle color="white" />
				</span>
			)
		case 'reference':
			return (
				<span className={clsx(styles.iconTile, styles.iconReference)}>
					<Play color="white" />
				</span>
			)
		case 'lyrics':
			return (
				<span className={clsx(styles.iconTile, styles.iconLyrics)}>
					<SearchLyrics color="black" />
				</span>
			)
		default:
			return undefined
	}
}

export function SearchSelectorOption({
	id,
	isActive,
	isSelected,
	onClick,
	onMouseEnter,
	type,
	...props
}: SearchSelectorOptionProps): JSX.Element {
	const { t } = useTranslation(['search'])

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events -- listbox keyboard handled on combobox
		<li
			aria-selected={isSelected}
			className={clsx(styles.option, isActive && styles.optionActive)}
			id={id}
			role="option"
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			{...props}
		>
			{getIcon(type)}
			<div className={styles.optionText}>
				<div className={styles.optionTitle}>
					{t(`search-selector.${type}-title`)}
				</div>
				<p className={styles.optionDescription}>
					{t(`search-selector.${type}-description`)}
				</p>
			</div>
		</li>
	)
}
